export default "/images/arrow-left.svg?9473cbdb301eb0251b5f9895e1505f36";